// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1PUBB","topBottomGutter":"Layout_topBottomGutter__3K4e3"};